export const LEGAL_BASIS_MAP = {
  '32014L0023': 'KonzVgV',
  '32014L0024': 'VgV',
  '32014L0025': 'SektVO',
  '32009L0081': 'VSVgV',
  '32007R1370': 'Verordnung (EG) Nr. 1370/2007',
  'other': 'Alle unterschwelligen Vergaberechtsrahmen',
};
